/**
 * Cleans and formats a phone number string
 * @param {string} number - Phone number string
 * @return {string} - Formatted phone number string
 */
const formatPhoneNumber = (number) => {
  if (!number) {
    return null;
  }
  const cleanedInput = number.replace(/\D/g, ''); // Clean input if there are any non-digits in the data
  return `(${cleanedInput.substring(0, 3)}) ${cleanedInput.substring(3, 6)}-${cleanedInput.substring(6, 10)}`;
};

export default formatPhoneNumber;
